function getShopDomain() {
    if ("object" == typeof Shopify && Shopify.hasOwnProperty("shop")) return Shopify.shop;
    for (let e = document.getElementsByTagName("script"), a = 0; a < e.length; a++) {
        if (e[a].hasAttribute("src") && e[a].src.indexOf("freeshippingbar") > -1) return e[a].src.substring(e[a].src.indexOf("shop=") + 5, e[a].src.length)
    }
    return document.domain
}

function serializeArray(form) {
  // Create a new FormData object
  const formData = new FormData(form);

  // Create an array to hold the name/value pairs
  const pairs = [];

  // Add each name/value pair to the array
  for (const [name, value] of formData) {
    pairs.push({ name, value });
  }

  // Return the array
  return pairs;
}

function setStorage(cname, value) {
    window.localStorage.setItem(cname, value);
}

function getStorage(cname) {
    return window.localStorage.getItem(cname);
}

function deleteStorage(cname) {
    window.localStorage.removeItem(cname);
}

function processContactForm(contactForm) {
    setStorage('contact_auto_reply', '1');
    let nameInput = contactForm.querySelector('#ContactForm-name');
    if (!nameInput) {
        nameInput = contactForm.querySelector('input[name="contact[name]"]');
        if (!nameInput) {
            nameInput = contactForm.querySelector('input[name="contact[Name]"]');
            if (!nameInput) {
                nameInput = contactForm.querySelector('input[name="contact[full-name]"]');
                if (!nameInput) {
                    nameInput = contactForm.querySelector('input[name="contact[first_name]"]');
                    if (!nameInput) {
                        nameInput = contactForm.querySelector('input[name="contact[firstname]"]');
                        if (!nameInput) {
                            nameInput = contactForm.querySelector('input[type=text]');
                        }
                    }
                }
            }
        }
    }
    let emailInput = contactForm.querySelector('#ContactForm-email');
    if (!emailInput) {
        emailInput = contactForm.querySelector('input[name="contact[email]"]');
        if (!emailInput) {
            emailInput = contactForm.querySelector('input[name="contact[Email]"]');
            if (!emailInput) {
                emailInput = contactForm.querySelector('input[type=email]');
            }
        }
    }

    let phoneInput = contactForm.querySelector('#ContactForm-phone');
    if (!phoneInput) {
        phoneInput = contactForm.querySelector('input[name="contact[phone]"]');
        if (!phoneInput) {
            phoneInput = contactForm.querySelector('input[name="contact[Phone]"]');
            if (!phoneInput) {
                phoneInput = contactForm.querySelector('input[type=tel]');
            }
        }
    }

    let detailsInput = contactForm.querySelector('#ContactForm-details');
    if (!detailsInput) {
        detailsInput = contactForm.querySelector('input[name="contact[details]"]');
        if (!detailsInput) {
            detailsInput = contactForm.querySelector('input[name="contact[Details]"]');
        }
    }

    let messageInput = contactForm.querySelector('#ContactForm-message');
    if (!messageInput) {
        messageInput = contactForm.querySelector('textarea[name="contact[body]"]');
        if (!messageInput) {
            messageInput = contactForm.querySelector('textarea[name="contact[Body]"]');
            if (!messageInput) {
                messageInput = contactForm.querySelector('textarea');
            }
        }
    }

    if (nameInput) {
        setStorage('contact_auto_reply_name', nameInput.value);
    }
    if (emailInput) {
        setStorage('contact_auto_reply_email', emailInput.value);
    }
    if (phoneInput) {
        setStorage('contact_auto_reply_phone', phoneInput.value);
    }
    if (detailsInput) {
        setStorage('contact_auto_reply_details', detailsInput.value);
    }
    if (messageInput) {
        setStorage('contact_auto_reply_message', JSON.stringify(messageInput.value));
    }
}

const queryParamString = window.location.search;

let contactForm = document.querySelector('#ContactForm');
if (!contactForm) {
    contactForm = document.querySelector('#contact_form');
    if (!contactForm) {
        contactForm = document.querySelector('#contact-us-page');
        if (!contactForm) {
            contactForm = document.querySelector('#contact-form');
        }
    }
}
if (!contactForm) {
    let allForms = document.querySelectorAll('form');
    allForms.forEach(function(form) {
        if (!contactForm && form.getAttribute('action').indexOf('/contact#') !== -1) {
            contactForm = form;
            return false;
        }
    });
}

if (window.location.href === 'https://www.dyedbro.com/pages/contact') {
    contactForm = false;
}

if (getShopDomain() === 'zeen-go.myshopify.com') {
    let allForms = document.querySelectorAll('#contact_form');
    if (allForms && allForms.length > 1) {
        contactForm = allForms[1];
    }
}

if (getShopDomain() === 'natalinoco.myshopify.com') {
    contactForm = document.querySelector('.wrap-mid #contact_form');
}

if (getShopDomain() === 'jbksd.myshopify.com') {
    contactForm = document.querySelector('#contact-template--15565181649091__form');
}

if (getShopDomain() === 'momentzweb.myshopify.com') {
    if (window.location.href.indexOf('pages/subscribe') !== -1) {
        contactForm = document.querySelector('#contact_form');
    } else {
        contactForm = false;
    }
}

if (getShopDomain() === 'line-furniture.myshopify.com') {
    contactForm = document.querySelectorAll('.artg-form #contact_form');
}

if (getShopDomain() === 'lost-found-to.myshopify.com' && window.location.href !== 'https://cryingoutloud.ca/pages/thoughtfull-gift-redemption') {
    contactForm = false;
}

if (getShopDomain() === 'nicety-studio-design.myshopify.com' && window.location.href === 'https://nicetystudio.com/pages/contact') {
    contactForm = false;
}

if (
    getShopDomain() === 'gray-viking-games.myshopify.com' ||
    getShopDomain() === 'line-furniture.myshopify.com' ||
    getShopDomain() === 'lost-found-to.myshopify.com' ||
    getShopDomain() === '609f75.myshopify.com' ||
    getShopDomain() === 'ec76e5-2.myshopify.com' ||
    getShopDomain() === 'enklsound.myshopify.com'
) {
    if (contactForm) {
        if (getShopDomain() === 'line-furniture.myshopify.com') {
            contactForm.forEach(item => {
                item.addEventListener('submit', function(event) {
                    if (!getStorage('wp_contact_form_data')) {
                        setStorage('contact_auto_reply', '1');
                        event.preventDefault();

                        let submitData = serializeArray(item);
                        let indexedArray = {};
                        submitData.map(function (n, i) {
                            indexedArray[n['name'].replace('contact[', '').replace(']', '')] = n['value'];
                        });
                        setStorage('wp_contact_form_data', JSON.stringify(indexedArray));
                    }
                });
            });
        } else {
            contactForm.addEventListener('submit', function(event) {
                if (!getStorage('wp_contact_form_data')) {
                    setStorage('contact_auto_reply', '1');
                    event.preventDefault();

                    // let submitData = serializeArray(document.querySelector('#contact_form, #ContactForm'));
                    let submitData = serializeArray(contactForm);
                    let indexedArray = {};
                    submitData.map(function(n, i){
                        indexedArray[n['name'].replace('contact[', '').replace(']', '')] = n['value'];
                    });
                    setStorage('wp_contact_form_data', JSON.stringify(indexedArray));

                    contactForm.submit();
                }
            });
            if (document.querySelector('.main-form-enquiry .enquiry_submitbtn') &&
                document.querySelector('.main-form-enquiry .enquiry_submitbtn').length > 0
            ) {
                document.querySelector('.enquiry_submitbtn').click(function() {
                    setStorage('contact_auto_reply', '1');

                    // let submitData = serializeArray(document.querySelector('#contact_form, #ContactForm'));
                    let submitData = serializeArray(contactForm);
                    let indexedArray = {};
                    submitData.map(function(n, i) {
                        indexedArray[n['name'].replace('contact[', '').replace(']', '')] = n['value'];
                    });

                    setStorage('wp_contact_form_data', JSON.stringify(indexedArray));
                });
            }
        }
    }
} else {
    if (contactForm) {
        let tagInput = contactForm.querySelector('input[name="contact[tags]"]');
        if (tagInput && tagInput.value === 'newsletter') {
            // this form is a newsletter form submission and we do nothing because newsletter is processed lower
        } else {
            if (getShopDomain() === 'lorenacanals-ohd-2.myshopify.com') {
                jQuery('#contact__submit_btn').click(function() {
                    processContactForm(contactForm);
                });
            } else {
                contactForm.addEventListener('submit', function(event) {
                    processContactForm(contactForm);
                });
            }
        }
    }
}

if (
    queryParamString.indexOf('contact_posted=true') !== -1 ||
    queryParamString.indexOf('challenge#ContactForm') !== -1 ||
    window.location.href.indexOf('pages/about') !== -1 ||
    window.location.href.indexOf('pages/complate') !== -1 ||
    window.location.href.indexOf('pages/complete') !== -1 ||
    window.location.href === 'https://sharkdesign.com/pages/book-a-call' ||
    (
        queryParamString.indexOf('contact') !== -1 &&
        queryParamString.indexOf('form_type=customer') !== -1
    )
) {
    if (document.referrer && (document.referrer.indexOf(window.location.hostname) !== -1) && getStorage('contact_auto_reply')) {
        if (
            getShopDomain() === 'gray-viking-games.myshopify.com' ||
            getShopDomain() === 'line-furniture.myshopify.com' ||
            getShopDomain() === 'lost-found-to.myshopify.com' ||
            getShopDomain() === '609f75.myshopify.com' ||
            getShopDomain() === 'ec76e5-2.myshopify.com' ||
            getShopDomain() === 'enklsound.myshopify.com'
        ) {
            let formData = getStorage('wp_contact_form_data');
            deleteStorage('contact_auto_reply');
            deleteStorage('wp_contact_form_data');

            fetch('https://contactautoreply.com/api/reply/send/?shop=' + getShopDomain(), {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    return {};
                }
            });
        } else {
            let name = getStorage('contact_auto_reply_name');
            let email = getStorage('contact_auto_reply_email');
            let phone = getStorage('contact_auto_reply_phone');
            let details = getStorage('contact_auto_reply_details');
            let message = getStorage('contact_auto_reply_message');
            deleteStorage('contact_auto_reply');
            deleteStorage('contact_auto_reply_name');
            deleteStorage('contact_auto_reply_email');
            deleteStorage('contact_auto_reply_phone');
            deleteStorage('contact_auto_reply_message');

            const data = {
                'name': name,
                'email': email,
                'phone': phone,
                'details': details,
                'message': JSON.parse(message),
            };
            // console.log(data);
            fetch('https://contactautoreply.com/api/reply/send/?shop=' + getShopDomain(), {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    return {};
                }
            });
        }
    }
}

// process newsletter submission
let allForms = document.querySelectorAll('form');
allForms.forEach(function(form) {
    // console.log(form);
    form.addEventListener('submit', function(event) {
        let tagInput = form.querySelector('input[name="contact[tags]"]');
        if (tagInput) {
            if (tagInput.value.includes('newsletter') || tagInput.value.includes('prospect')) {
                setStorage('newsletter_auto_reply', '1');
                let emailInput = form.querySelector('input[type=email]');
                if (!emailInput) {
                    emailInput = form.querySelector('input[type=text]');
                }
                if (emailInput) {
                    setStorage('newsletter_auto_reply_email', emailInput.value);
                } else {
                    setStorage('newsletter_auto_reply_email', 0);
                }
            }
        }
    });
});

if (
    (
        queryParamString.indexOf('=newsletter') !== -1 ||
        queryParamString.indexOf('customer_posted=true') !== -1 ||
        queryParamString.indexOf('customer_posted=true') !== -1
    ) ||
    (
        window.location.href.indexOf('blogs/news') !== -1 &&
        document.referrer.indexOf('challenge') !== -1
    )
) {
    if (
        document.referrer && (document.referrer.indexOf(window.location.hostname) !== -1) && getStorage('contact_auto_reply')
    ) {
        let name = getStorage('contact_auto_reply_name');
        let email = getStorage('contact_auto_reply_email');
        let phone = getStorage('contact_auto_reply_phone');
        let details = getStorage('contact_auto_reply_details');
        let message = getStorage('contact_auto_reply_message');
        deleteStorage('contact_auto_reply');
        deleteStorage('contact_auto_reply_name');
        deleteStorage('contact_auto_reply_email');
        deleteStorage('contact_auto_reply_phone');
        deleteStorage('contact_auto_reply_details');
        deleteStorage('contact_auto_reply_message');

        const data = {
            'email': email
        };
        fetch('https://contactautoreply.com/api/reply/sendnewsletter/?shop=' + getShopDomain(), {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status === 200) {
                return response.json();
            } else {
                return {};
            }
        });
    }

    if (document.referrer && (document.referrer.indexOf(window.location.hostname) !== -1) && getStorage('newsletter_auto_reply')) {
        var email = getStorage('newsletter_auto_reply_email');
        deleteStorage('newsletter_auto_reply');
        deleteStorage('newsletter_auto_reply_email');

        const data = {
            'email': email
        };
        fetch('https://contactautoreply.com/api/reply/sendnewsletter/?shop=' + getShopDomain(), {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status === 200) {
                return response.json();
            } else {
                return {};
            }
        });
    }
}